"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMediaURL = void 0;
const createMediaURL = (baseUrl, mediaApiUrl, url) => {
    const pattern = /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%\-\/]))?/;
    if (pattern.test(url)) {
        return url;
    }
    return `${baseUrl}${mediaApiUrl}${url}`;
};
exports.createMediaURL = createMediaURL;
//# sourceMappingURL=mediaUtil.js.map